import SubcategoryPage from '@/components/template/SubcategoryPage';

const OrdinaStool = () => {
  const products = [
    {
      title: "Ordina Stool Classic",
      imageSrc: "https://images.unsplash.com/photo-1503602642458-232111445657?auto=format&fit=crop&q=80",
      url: "/proizvodi/ordina-stool-classic"
    },
    {
      title: "Ordina Stool Modern",
      imageSrc: "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?auto=format&fit=crop&q=80",
      url: "/proizvodi/ordina-stool-modern"
    },
    {
      title: "Ordina Stool Premium",
      imageSrc: "https://images.unsplash.com/photo-1562663474-6cbb3eaa4d14?auto=format&fit=crop&q=80",
      url: "/proizvodi/ordina-stool-premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Ordina Stool"
      description="Minimalistični in funkcionalni Ordina stolčki za sodoben življenjski slog."
      heroImage="https://images.unsplash.com/photo-1503602642458-232111445657?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default OrdinaStool;